<template lang="pug">
  .box
    .banner
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide>
          a(href="https://appgallery.huawei.com/#/app/C102888969?locale=zh_CN&source=appshare&subsource=C102888969&shareTo=weixin&shareFrom=appmarket" target="_blank")
            img(src="https://file.s5yun.com/resources/appico/16155115363871836_轮播图速云APP.jpg" alt="")
        </swiper-slide>
        <swiper-slide>
          img(src="../assets/img/home/banner2.jpg" alt="" @click="goCase")
        </swiper-slide>
        <swiper-slide>
          img(src="../assets/img/home/banner3.jpg" alt="" @click="goWe")
        </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    .nav
      ul
        li(:class="[flag==1?'border-blue':'']" @click="synopsis")
          a(href="javascript:;") 公司简介
        li(:class="[flag==2?'border-blue':'']" @click="history")
          a(href="javascript:;") 企业文化
        li(:class="[flag==3?'border-blue':'']" @click="intelligence")
          a(href="javascript:;") 使命愿景
        li(:class="[flag==4?'border-blue':'']" @click="mission")
          a(href="javascript:;") 联系我们
        li(@click="recruit(1)")
          a(href="javascript:;") 招贤纳士
        li(@click="recruitment(1)")
          a(href="javascript:;") 伙伴招募
    .synopsisBox
      .synopsis
        .synopsisLeft
          .tilte
            h3 速云简介
            em
          p 速云软件专注于企业管理软件的研发、销售和服务，为企业提供信息化建设与软件解决方案。公司将软件的行业化作为产品的定位方向，目前已拥有自主研发品牌“速云”，和数十项国家级专利证书。自成立以来，速云软件持续为初创型中小企业、大型集团公司、政府机关部门、学校教育机构等各类组织提供集信息门户定制、公文流转、财务审批、培训管理等一体化解决方案。“用心服务，共创价值”，未来，速云软件愿助力更多的组织实现实现数字化变革！
        .synopsisRight(:class="[flag2==true?'rightFadeIn':'']")
          img(src="https://file.s5yun.com/resources/appico/16155115216206147_公司.png" alt="")
    .historyBox
      .history
        .tilte
          h3 企业文化
          em
        .body
          .dateBox
             .date 企业标语
             .date 企业价值观
             .date 团队理念
             .date 工作方式
          .dateLine
            .line
              em
              .wire
            .line
              em
              .wire
            .line
              em
              .wire
            .line
              em
              .wire
          .dataBox
            .data
              img(src="../assets/icon/g1.jpg" alt="")
            .data
              img(src="../assets/icon/g2.png" alt="")
            .data
              img(src="../assets/icon/g3.png" alt="")
            .data
              img(src="../assets/icon/g4.jpg" alt="")
    .missionBox
      .mission
        .tilte
          h3 使命愿景
          em
        .one
          img(src="../assets/img/img2.jpg" alt="" :class="[flag4==true?'leftDown':'']")
          .introduce(:class="[flag4==true?'rightDown':'']")
            h2 01.
            h3 企业使命
            p 让人人享受数智生活
        .one
          img(src="../assets/img/img1.jpg" alt="" :class="[flag5==true?'rightDown':'']")
          .introduce(:class="[flag5==true?'leftDown':'']")
            h2 02.
            h3 企业愿景
            p 致力于推进和改变互联数智时代下人们的工作和生活；
            p 打造一支敢想敢拼的队伍；
            p  建设一个互联数智的服务平台!
        .one
          img(src="../assets/img/img3.jpg" alt="" :class="[flag6==true?'leftDown':'']")
          .introduce(:class="[flag6==true?'rightDown':'']")
            h2 03.
            h3 企业信念
            p 每个速云人都会长出飞翔的翅膀，翱翔天空!
    .mapBox
      .maps(style="width:70%;margin:0 auto;")
        .tilte
          h3 联系我们
          em
      <div id="map"></div>
      .newsNav
        ul
          li
            <i class="iconfont icondianhua"></i>
            p 400-0931-866
          li
            <i class="iconfont iconditu1"></i>
            p 甘肃省兰州市城关区东岗东路55号兰州科技创新园C座4026室
          li
            <i class="iconfont iconyoujianqudao"></i>
            p lzsyrjkj@163.com
    .nav1(v-if="flag3==true")
      ul
        li(:class="[flag==1?'border-blue':'']" @click="synopsis")
          a(href="javascript:;") 公司简介
        li(:class="[flag==2?'border-blue':'']" @click="history")
          a(href="javascript:;") 企业文化
        li(:class="[flag==3?'border-blue':'']" @click="intelligence")
          a(href="javascript:;") 使命愿景
        li(:class="[flag==4?'border-blue':'']" @click="mission")
          a(href="javascript:;") 联系我们
        li(@click="recruit()")
          a(href="javascript:;") 招贤纳士
        li(@click="recruitment()")
          a(href="javascript:;") 伙伴招募
</template>

<script>
export default {
  data () {
    return {
      flag: 1,
      flag2: false,
      flag3: false,
      scrollTop: 0,
      flag4: false,
      flag5: false,
      flag6: false,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        slidesPerView: 1,
        loop: true,
        centeredSlides: true
      }
    }
  },
  created () {
    this.$store.commit('changeNav', 7)
  },
  methods: {
    // 导航栏的显示隐藏
    handle (e) {
      e = e || window.event
      if (e.wheelDelta) {
        if (e.wheelDelta > 0) {
          this.flag3 = false
        } else if (e.wheelDelta < 0) {
          if (this.scrollTop > 540) {
            this.flag3 = true
          } else {
            this.flag3 = false
          }
        }
      } else if (e.detail) {
        if (e.detail > 0) {
          this.flag3 = false
        } else if (e.detail < 0) {
          if (this.scrollTop > 540) {
            this.flag3 = true
          } else {
            this.flag3 = false
          }
        }
      }
    },
    // 对页面滚动的监听
    handleScroll1 () {
      // console.log(window.pageYOffset)
      // 页面上卷的距离
      this.scrollTop = window.pageYOffset
      if (window.pageYOffset === 0) {
        this.flag3 = false
      }
      if (window.pageYOffset <= 1050) {
        this.flag = 1
      } else if (window.pageYOffset <= 2518) {
        this.flag = 2
      } else if (window.pageYOffset <= 3872) {
        this.flag = 3
      } else if (window.pageYOffset > 3872) {
        this.flag = 4
      }
      // 导航下划线的显示与隐藏
      var top = document.documentElement.scrollTop || document.body.scrollTop
      if (top > 340) {
        this.flag2 = true
      }
      if (top > 2467) {
        this.flag4 = true
      }
      if (top > 2879) {
        this.flag5 = true
      }
      if (top > 3264) {
        this.flag6 = true
      }
    },
    intelligence () {
      this.flag = 3
      this.animate(this.scrollTop, 2509)
    },
    history () {
      this.flag = 2
      this.animate(this.scrollTop, 1184)
    },
    synopsis () {
      this.flag = 1
      this.animate(this.scrollTop, 609)
    },
    mission () {
      this.flag = 4
      this.animate(this.scrollTop, 3872)
    },
    // 动画效果
    animate (currentY, targetY) {
      var needScrollTop = targetY - currentY
      var _currentY = currentY
      setTimeout(() => {
        const dist = Math.ceil(needScrollTop / 10)
        _currentY += dist
        window.scrollTo(_currentY, currentY)
        if (needScrollTop > 10 || needScrollTop < -10) {
          this.animate(_currentY, targetY)
        } else {
          window.scrollTo(_currentY, targetY)
        }
      }, 15)
    },
    recruit () {
      var routeUrl = this.$router.resolve({
        path: '/recruit',
        query: {}
      })
      window.open(routeUrl.href, '_blank')
    },
    recruitment () {
      var routeUrl = this.$router.resolve({
        path: '/recruitments',
        query: {}
      })
      window.open(routeUrl.href, '_blank')
    },
    goCase () {
      window.scroll(0, 0)
      this.$router.push('/case')
    },
    goWe () {
      window.scroll(0, 0)
      this.$router.push('/we')
    }
  },
  mounted () {
    document.title = '速云官网'
    window.addEventListener('scroll', this.handleScroll1)
    window.addEventListener('wheel', this.handle)
    window.addEventListener('DOMMouseScroll', this.handle)
    window.addEventListener('mousewheel', this.handle)
    var map = new AMap.Map('map', {
      resizeEnable: true,
      center: [103.923330, 36.039369],
      zoom: 15
    })
    var icon1 = new AMap.Icon({
      size: new AMap.Size(25, 30),
      image: 'https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
      imageSize: new AMap.Size(25, 30)
    })
    var marker = new AMap.Marker({
      icon: icon1,
      position: [103.923330, 36.039369],
      offset: new AMap.Pixel(-13, -30)
    })
    marker.setMap(map)
    marker.setLabel({
      offset: new AMap.Pixel(0, -5),
      content: "<div class='info'>兰州速云软件科技有限公司</div>",
      direction: 'top'
    })
  }
}
</script>

<style lang="less" scoped>
  .box{
    .banner{
      width: 100%;
      img{
        width: 100%;
        vertical-align: middle;
      }
    }
    // 导航
    .nav1,.nav{
      height: 95px;
      width: 70%;
      margin: 0 auto;
      ul{
        width: 100%;
        height: 95px;
        li{
          float: left;
          width: 100px;
          margin-right: 50px;
          padding: 28px 0;
          cursor: pointer;
          a{
            font-size: 24px;
            color: #333;
          }
        }
        .border-blue{
          border-bottom: 3px solid #007BF9;
        }
      }
    }
    .nav1{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      box-shadow: 1px 1px 2px rgba(0, 0, 0, .3);
      ul{
        width: 70%;
        margin: 0 auto;
      }
    }
    // 速云简介
    .synopsisBox{
      border-top: 1px solid #E6E6E6;
      width: 100%;
      height: 555px;
      background-color: #F4F4F4;
      .synopsis{
        width: 70%;
        height: 100%;
        margin: 0 auto;
        overflow: hidden;
        .synopsisLeft,.synopsisRight{
          margin-top: 85px;
          float: left;
        }
        .synopsisLeft{
          width: 40%;
          p{
            font-size: 16px;
            line-height: 36px;
            margin-top: 20px;
          }
        }
        .synopsisRight{
          width: 54%;
          margin-left: 52px;
          transform: translateX(2000px);
          img{
            height: 450px;
            vertical-align: middle;
          }
        }
      }
    }
    // 发展历史
    .historyBox{
      width: 100%;
      height: 1469px;
      overflow: hidden;
      .history{
        width: 70%;
        margin: 40px auto;
        .body{
          margin-top: 60px;
          margin-left: 60px;
          .dateBox,.dateLine,.dataBox{
            float: left;
          }
          .dateBox{
            //margin-top: 5px;
            .date{
              height: 296px;
              font-size: 24px;
            }
          }
          .dateLine{
            margin-top: 5px;
            .line{
              width: 12px;
              height: 296px;
              margin-left: 65px;
              em{
                display: block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background-color: #666;
              }
              .wire{
                height: 284px;
                width: 1px;
                background-color: #666;
                margin-left: 5px;
              }
            }
          }
          .dataBox{
            width: 60%;
            margin-top: 5px;
            margin-left: 77px;
            .data{
              width: 100%;
              height: 296px;
              img{
                width: 96%;
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
    // 使命愿景
    .missionBox{
      width: 100%;
      // margin-bottom: 60px;
      padding: 40px 0 60px;
      background-color: #F4F4F4;
      .mission{
        width: 70%;
        margin: 0 auto;
        .one{
          position: relative;
          width: 100%;
          margin-top: 50px;
          overflow: hidden;
          img{
            width: 50%;
            transform-origin: left bottom;
            transform: rotate(-180deg);
          }
          .introduce{
            position: absolute;
            top: 47px;
            right: 0px;
            width: 55%;
            height: 73%;
            background-color: #fff;
            transform-origin: right bottom;
            transform: rotate(180deg);
            h2{
              padding: 20px 0 0 50px;
              font-size: 48px;
              color: #999;
              font-weight: 400;
            }
            h3{
              padding: 30px 0 15px 50px;
              font-size: 32px;
              color: #333;
              font-weight: 400;
            }
            p{
              padding-left: 50px;
              font-size: 20px;
              width: 300px;
              color: #333;
            }
          }
          .introduce:hover{
            background-color: #007BF9;
            h2,h3,p{
              color: #fff;
            }
          }
        }
        .one:nth-child(3){
          img{
            margin-left: 473px;
            transform-origin: right bottom;
            transform: rotate(180deg);
          }
          .introduce{
            right: 423px;
            transform-origin: left bottom;
            transform: rotate(-180deg);
            h3{
              padding-top: 0;
            }
          }
        }
      }
    }
    // 联系我们
    .mapBox{
      position: relative;
      width: 100%;
      height: 850px;
      border-top: 1px solid #E6E6E6;
      padding-top: 40px;
      #map{
        width: 70%;
        height: 589px;
        margin: 42px auto 0;
      }
      .newsNav{
        position: absolute;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
        width: 85%;
        height: 168px;
        box-shadow: 0px 0px 7px 2px rgba(0, 123, 249, 0.1);
        background-color: #fff;
        z-index: 2021;
        ul{
          li{
            float: left;
            width: 33.33%;
            text-align: center;
            margin-top: 30px;
            .iconfont{
              font-size: 34px;
              color: #007bf9;
            }
            .icondianhua{
              font-size: 26px;
            }
            p{
              margin-top: 44px;
              font-size: 18px;
              color: #666;
            }
          }
          li:nth-child(1){
            margin-top: 34px;
            p{
              margin-top: 49px;
            }
          }
        }
      }
    }
  }
  .tilte{
    h3{
      font-size: 48px;
      color: #333;
      font-weight: 400;
    }
    em{
      display: inline-block;
      width: 40px;
      height: 2px;
      background-color: #007BF9;
    }
  }
  // 动画
  .rightFadeIn{
    animation: rightFadeIn 1s ease forwards;
  }
  .rightDown{
    animation: rotateDownRight 1s ease forwards;
  }
  .leftDown{
    animation: rotateDownLeft 1s ease forwards;
  }
  //右边淡入
  @keyframes rightFadeIn {
    0% {
      transform: translateX(2000px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  //左下角旋转进入
  @keyframes rotateDownLeft {
    0% {
      transform-origin: left bottom;
      transform: rotate(-180deg);
      opacity: 0;
    }
    100% {
      transform-origin: left bottom;
      transform: rotate(0);
      opacity: 1;
    }
  }
  //右下角旋转进入
  @keyframes rotateDownRight {
    0% {
      transform-origin: right bottom;
      transform: rotate(180deg);
      opacity: 0;
    }
    100% {
      transform-origin: right bottom;
      transform: rotate(0);
      opacity: 1;
    }
  }
  //原地旋转进入
  @keyframes rotateIn {
    0% {
      transform: rotate(-200deg);
      opacity: 0;
    }
    100% {
      transform: rotate(0);
      opacity: 1;
    }
  }
</style>
